export const percentageParams = ["slow_capacity_share", "interest_rate", "deposits.reporter_share", "moved_capacity_share", "sf_capacity_share"];